// Names Statsig experiment variants by index: control first, then numbered variants.
export function getVariantDisplayName(variantIndex: number): string {
  if (variantIndex === 0) return 'Control';
  return `Variant ${variantIndex}`;
}
